import React, { useState, useEffect } from 'react';
import ReactDatePicker from 'react-datepicker';
import { format } from 'date-fns';
import { he } from 'date-fns/locale';
import '../../../modules/datepicker/react-datepicker.css';
import DatePickerShell from './DatePickerShell';

export interface DatePickerProps {
    selected?: Date | false;
    setDate: (value: string) => void;
    onChange?: (date: Date | null) => void;
    disabled?: boolean;
    width?: string;
    mobileWidth?: string;
    className?: string;
}

const resolveInitial = (selected: Date | false | undefined): Date => {
    if (selected instanceof Date) return selected;
    return new Date();
};

const DatePicker: React.FC<DatePickerProps> = ({
    selected,
    setDate,
    onChange,
    disabled,
    width = '11rem',
    mobileWidth = '9rem',
    className,
}) => {
    const [date, setLocalDate] = useState<Date | null>(resolveInitial(selected));

    const handleChange = (next: Date | null) => {
        setLocalDate(next);
        onChange?.(next);
    };

    useEffect(() => {
        if (date) setDate(format(date, 'yyyyMMdd'));
    }, [date, setDate]);

    return (
        <DatePickerShell
            className={className}
            width={width}
            mobileWidth={mobileWidth}
        >
            <ReactDatePicker
                className='datePicker'
                selected={date ?? undefined}
                onChange={handleChange}
                dateFormat='dd/MM/yyyy'
                locale={he}
                disabled={disabled}
                popperProps={{ strategy: 'fixed' }}
                popperClassName='ui-datepicker-popper'
                // inputMode none: tapping the field opens the calendar without the on-screen keyboard;
                // desktop typing still works.
                customInput={<input type='text' inputMode='none' />}
                popperPlacement='bottom-end'
                value={date ? format(date, 'dd/MM/yyyy') : ''}
            />
        </DatePickerShell>
    );
};

export default DatePicker;
